module.exports = __webpack_public_path__ + "img/inventario_3.a3053f16.svg";